import { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { TECH_STACK_CARDS } from './techStackData';
import TechStackCard from './techStackCard';

const cardsContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      delayChildren: 0.6,
      staggerChildren: 0.35,
    },
  },
};

const TechStackSection = () => {
  const scrollRef = useRef(null);

  const scrollByCard = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const card = container.querySelector('[data-tech-card]');
    const gap = 24;
    const step = card ? card.offsetWidth + gap : 300;
    container.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  return (
    <div className="flex flex-col items-center bg-white sm:py-20 sm:px-[120px] py-10 gap-5 sm:gap-10">
      <div className="flex items-center justify-between w-full px-5 sm:px-0 sm:justify-center max-w-[1200px]">
        <motion.div
          className="text-[24px] leading-[30px] sm:text-[40px] sm:leading-[52px] tracking-[0.02em] sm:tracking-[0.04em] text-left sm:text-center text-[#020617] font-gilroy-bold"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          Modern Engineering Tech Stack
        </motion.div>
        <div className="flex items-center gap-3 sm:hidden shrink-0">
          <button
            type="button"
            aria-label="Previous tech stack card"
            onClick={() => scrollByCard(-1)}
            className="flex items-center justify-center w-8 h-8 rounded-full bg-[#292C33] text-[#F8FAFC]"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            aria-label="Next tech stack card"
            onClick={() => scrollByCard(1)}
            className="flex items-center justify-center w-8 h-8 rounded-full bg-[#292C33] text-[#F8FAFC]"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <motion.div
        ref={scrollRef}
        className="no-scrollbar flex sm:flex-wrap sm:justify-center gap-6 w-full max-w-[1200px] overflow-x-auto sm:overflow-visible snap-x snap-mandatory px-6 sm:px-0"
        style={{ scrollPaddingLeft: '24px' }}
        variants={cardsContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {TECH_STACK_CARDS.map((card) => (
          <div key={card.id} data-tech-card className="shrink-0 snap-start">
            <TechStackCard {...card} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default TechStackSection;
